import { useEffect } from 'react';
export default function useOnResize(onResize) {
    useEffect(()=>{
        // The first render runs `onResize` to trigger an update after SSR
        onResize();
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, [
        onResize
    ]);
}
